import { forwardRef } from 'react';
import moment from 'moment';
import IcDot from '../../../../assets/image/report/ic_dots_btn.svg';
// import IcRightArrow from '../../../../assets/image/ic_chevron_right.svg';
import IcComment from '../../../../assets/image/community/ic_comment.svg';
import IcLike from '../../../../assets/image/community/ic_like.svg';

interface PostCardProps {
  post: any;
  onClick: (id: any) => void;
  onOptionClick: (id: any) => void;
}

const PostCard = forwardRef<HTMLDivElement, PostCardProps>(
  ({ post, onClick, onOptionClick }, ref) => {
    return (
      <div
        ref={ref}
        className="w-full relative flex items-center justify-between py-4 border-b border-gray-200 hover:bg-gray-50 overflow-hidden"
      >
        <button
          type="button"
          className="z-10 w-[20px] h-[20px] absolute top-3 right-[-1px] flex items-center justify-center gap-1"
          onClick={() => onOptionClick(post?.id)}
        >
          <img src={IcDot} alt="more options" className="w-[18px] h-[18px]" />
        </button>
        <button
          type="button"
          className="w-full min-w-0 overflow-hidden relative"
          onClick={() => onClick(post?.id)}
        >
          <div className="w-full text-left font-[700] mb-1 text-[16px]">{post?.title}</div>
          <div className="w-full mb-3 text-left font-[400] text-[12px] text-[#363636] truncate overflow-hidden whitespace-nowrap">
            {post?.content}
          </div>
          <div className="w-full flex justify-between items-center">
            <div className="text-xs text-gray-500">
              {moment(post?.createdAt).format('YY.MM.DD')}
            </div>
            <div className="flex justify-end items-center text-[12px]">
              <img src={IcComment} alt="chevron right" className="w-[18px] h-[18px]" />
              <span className="ml-1 text-[#969696]">{post?.commentCount}</span>
              <img src={IcLike} alt="chevron right" className="ml-2 w-[18px] h-[18px]" />
              <span className="ml-1 text-[#969696]">{post?.likeCount}</span>
            </div>
          </div>
        </button>
        {/* <div className="shrink-0 flex items-center justify-center w-[20px]">
        <img src={IcRightArrow} alt="chevron right" className="min-w-[18px] w-[18px] h-[18px]" />
      </div> */}
      </div>
    );
  }
);

export default PostCard;
